export enum MandateStatus {
  REJECTED = "Rejected",
  CANCELLED = "Cancelled",
  UNDER_PROCESSING = "Under Processing",
  ACTIVE = "Active",
  PENDING = "Pending",
  APPROVED = "Approved",
}

export enum MandateType {
  X = "X",
  E = "E",
}
